import { selectPaymentsDualPricing, selectPaymentsListPrice, selectPaymentsCardCashPrice } from './chunk-PHOCK55S.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import cloneDeep from 'lodash/cloneDeep';
import { useSelector } from 'react-redux';

var PRICES = [
  "itemPrice",
  "onlinePrice",
  "deliveryPrice",
  "toGoPrice"
];
var useItemDualPricing = (menuTypeVersion) => {
  const dualPricing = useSelector(selectPaymentsDualPricing);
  const listPrice = useSelector(selectPaymentsListPrice);
  const cardCashPrice = useSelector(selectPaymentsCardCashPrice);
  const basePrice = {};
  PRICES.forEach((price) => {
    basePrice[price] = menuTypeVersion[price];
  });
  const dualPrice = cloneDeep(basePrice);
  if (dualPricing) {
    PRICES.forEach((price) => {
      const percentage = cardCashPrice / 100;
      const total = basePrice[price] + menuTypeVersion.defaultModifiersPrice;
      if (listPrice === "card" /* CARD */) {
        dualPrice[price] = Number((total - total * percentage).toFixed(2));
      } else {
        dualPrice[price] = Number((total + total * percentage).toFixed(2));
      }
    });
  }
  return {
    dualPricing,
    listPrice,
    cardCashPrice,
    basePrice,
    basePriceLabel: i18n_config_default.t(
      `settingsModule.paymentsSettings.dualPricing.listPrice.options.${listPrice}`
    ),
    dualPriceLabel: i18n_config_default.t(
      `settingsModule.paymentsSettings.dualPricing.listPrice.options.${listPrice === "card" /* CARD */ ? "cash" /* CASH */ : "card" /* CARD */}`
    ),
    dualPrice
  };
};

export { useItemDualPricing };
